import BOOKING_ACTION_TYPES from 'constants/bookingActionTypes';
import ENGRAVING_ACTION_TYPES from 'constants/engravingActionTypes';

const updateBooking = (payload) => {
    return {
        type: BOOKING_ACTION_TYPES.update,
        payload
    };
};

const clearBooking = () => {
    return { type: BOOKING_ACTION_TYPES.clear };
};

const updateEngraving = (payload) => {
    return {
        type: ENGRAVING_ACTION_TYPES.update,
        payload
    };
};

const clearEngraving = () => {
    return { type: ENGRAVING_ACTION_TYPES.clear };
};

export {
    updateBooking,
    clearBooking,
    updateEngraving,
    clearEngraving
};
